// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 1803 ? "pages/packages/styleguide/inventory.page.styleguide.package" : chunkId) + "-" + {"1803":"e99ec8","6177":"45d1e6"}[chunkId] + ".js";
};